import {getValueFromSurveyData} from 'utils/getValueFromSurveyData';
import styles from './RiseClinicFeatureList.module.css';
import {formatAppointmentTime} from '../../utils';

const ChatIcon = () => (
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21.9971 11.6914C22.3469 11.4202 22.8425 11.4583 23.1475 11.7705H23.1572L23.1973 11.8223C24.0398 12.9047 24.4952 14.2388 24.4883 15.6113C24.4794 16.9874 24.0133 18.321 23.165 19.4043C22.3368 20.4617 21.1875 21.2191 19.8926 21.5693C19.8869 21.9506 19.9369 22.3307 20.0459 22.6973L20.0889 22.8848C20.1474 23.2628 20.0351 23.6485 19.7822 23.9355L19.6445 24.0703C19.297 24.3643 18.8248 24.4501 18.4014 24.3086L18.2236 24.2334C17.3157 23.7732 16.1188 22.991 15.3213 21.7871H14.9277C13.735 21.7861 12.5687 21.4392 11.5703 20.7881L11.5596 20.7812L11.5605 20.7803C11.215 20.5002 11.1371 20.0044 11.3799 19.6318C11.6076 19.2825 12.0486 19.1475 12.4287 19.3008L12.5029 19.335L12.5146 19.3408L12.4492 19.4414L12.5146 19.3418C13.2299 19.8097 14.0655 20.0597 14.9209 20.0635H15.8086L15.9277 20.0713C16.2033 20.1088 16.4468 20.2776 16.5781 20.5283H16.5771C16.9713 21.2125 17.5226 21.7909 18.1826 22.2207C18.131 21.7315 18.1418 21.2367 18.2158 20.749L18.2471 20.6055C18.3448 20.2827 18.6237 20.0409 18.9668 19.9971C20.0181 19.8353 20.9781 19.3037 21.6719 18.4971C22.3657 17.6913 22.7491 16.6639 22.7529 15.5996L22.75 15.416C22.7143 14.4979 22.3909 13.6108 21.8242 12.8828L21.8213 12.8789C21.5526 12.4995 21.6301 11.976 21.9971 11.6914ZM13.0664 0.125977V0.126953C15.2788 0.0882664 17.4126 0.939217 18.9902 2.48926C20.5684 4.04097 21.458 6.16079 21.458 8.37402C21.4579 10.5862 20.5683 12.7062 18.9902 14.2568C17.4126 15.8079 15.2787 16.6578 13.0664 16.6201L12.333 16.6211C11.2693 18.3155 9.5933 19.4168 8.33008 20.0547C7.8428 20.3011 7.26146 20.2544 6.82227 19.9395L6.73633 19.8721C6.28837 19.4979 6.10638 18.8942 6.27344 18.3359C6.45856 17.7098 6.5315 17.0562 6.49316 16.4053C3.86745 15.7907 1.70515 13.9311 0.708008 11.4219C-0.300856 8.88177 0.0128689 6.00833 1.5459 3.74609L1.69238 3.53613C3.23866 1.40102 5.71838 0.128829 8.36523 0.125977H13.0664ZM8.3291 1.85938C6.1295 1.87349 4.08428 2.99645 2.89355 4.84766C1.69597 6.70756 1.52527 9.04921 2.43945 11.0635C3.35374 13.0785 5.22755 14.4909 7.41602 14.8154C7.79309 14.8708 8.09076 15.1669 8.14746 15.5439L8.19629 15.9121C8.27866 16.6791 8.2402 17.4535 8.08789 18.21C9.1532 17.5976 10.3734 16.6647 11.0635 15.3496C11.2136 15.064 11.5102 14.8848 11.832 14.8857H13.0723C14.8209 14.9198 16.5099 14.2487 17.7588 13.0234L17.9863 12.7891C19.0929 11.5898 19.7118 10.0145 19.7119 8.37402C19.7119 6.62424 19.0078 4.948 17.7588 3.72266C16.5097 2.49838 14.8209 1.82731 13.0723 1.86133H8.33301L8.3291 1.85938Z"
      fill="var(--color-web-purple1)"
      stroke="var(--color-web-purple1)"
      strokeWidth="0.25"
    />
  </svg>
);

const CheckIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.42 6.76178C14.8106 6.37126 15.4436 6.37126 15.8341 6.76178C16.2246 7.15231 16.2246 7.78534 15.8341 8.17584L9.8175 14.1934C9.62999 14.3809 9.37469 14.4864 9.1095 14.4864C8.84449 14.4863 8.58988 14.3808 8.40247 14.1934L4.26575 10.0567C3.87522 9.66618 3.87522 9.03219 4.26575 8.64166C4.65627 8.25114 5.29026 8.25114 5.68079 8.64166L9.11047 12.0704L14.42 6.76178Z"
      fill="black"
    />
  </svg>
);

export const RiseClinicFeatureList = () => {
  const appointmentStartTime = getValueFromSurveyData('appointment_start_time');
  const appointmentEndTime = getValueFromSurveyData('appointment_end_time');

  const formattedAppointmentTime = formatAppointmentTime(appointmentStartTime, appointmentEndTime);

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.feature}>
          <div className={styles.iconWrapper}>
            <ChatIcon />
          </div>
          <div className={styles.featureContent}>
            <div className={styles.featureMainTitle}>Expert chat</div>
            <div className={styles.featureSubtext}>{formattedAppointmentTime}</div>
          </div>
        </div>

        <div className={styles.feature}>
          <div className={styles.iconWrapper}>
            <CheckIcon />
          </div>
          <div className={styles.featureContent}>
            <div className={styles.featureTitle}>
              Start with 1 chat: <span className={styles.normalWeight}>Continue as needed</span>
            </div>
          </div>
        </div>

        <div className={styles.feature}>
          <div className={styles.iconWrapper}>
            <CheckIcon />
          </div>
          <div className={styles.featureContent}>
            <div className={styles.featureTitle}>
              Comprehensive data analysis:{' '}
              <span className={styles.normalWeight}>Find root causes with personalized guidance</span>
            </div>
          </div>
        </div>

        <div className={styles.feature}>
          <div className={styles.iconWrapper}>
            <CheckIcon />
          </div>
          <div className={styles.featureContent}>
            <div className={styles.featureTitle}>
              Covered by insurance:{' '}
              <span className={styles.normalWeight}>$0 due today, Fully covered by your insurance</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
